// Re-export the SDK's DocumentResponse and extend it with capture-app specific properties
export { DocumentResponse, ContentMetadata } from '@softdocs/capture-ui-libraries';

import { TranscriptType } from '../constants';

export interface TranscriptMetadata extends StandardizedDocumentResponse {
  transId: string;
  documentUrl?: string;
  origData?: string;
  savedData?: string;
  statusId?: number;
  statusName?: string;
  typeId?: TranscriptType;
  typeMismatch?: boolean;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  confidenceScore?: number;
  lockedByUser?: string | null;
  lockedByUserId?: string;
  lockedByUserName?: string;
  isAssigned?: boolean;
  ecmDocId?: number;
  transcriptData?: {
    content: string;
    transId: string;
    documentId: string;
    statusId: number;
    isEdited: boolean;
  };
  student_name?: string;
  confidence_score?: string;
}

export interface StandardizedDocumentResponse {
  fileName: string;
  documentId?: string;
  contentUri: string;
  createdAt: string;
  updatedAt?: string;
  extractionStatus?: string;
}

/**
 * Normalizes a document response to ensure both id and documentId are present
 * @param response
 */
export function normalizeDocumentResponse(response: any): any {
  return {
    ...response,
    // Ensure both id and documentId exist regardless of which one came from API
    id: response.id || response.documentId,
    documentId: response.documentId || response.id
  };
}

/**
 * Maps a raw transcript metadata API response into the TranscriptMetadata model.
 * @param doc The raw transcript metadata response
 */
export function mapToTranscriptMetadata(doc: any): TranscriptMetadata {
  return {
    documentId: doc.documentId,
    transId: doc.transId,
    fileName: doc.fileName,
    documentUrl: doc.documentUrl,
    contentUri: doc.contentUri || doc.documentUrl || '',
    createdAt: doc.createdAt || '',
    updatedAt: doc.updatedAt || '',
    extractionStatus: doc.extractionStatus || doc.statusName || '',
    lockedByUser: doc.lockedByUserName || doc.lockedByUser || null,
    confidenceScore: doc.confidenceScore || null,
    ecmDocId: doc.ecmDocId,
    typeId: doc.typeId,
    typeMismatch: doc.typeMismatch
  };
}
